import React from "react";
import { Helmet } from "react-helmet";

import DeliveryProcess from "./ProcessComponents/HowToComponents/DeliveryProcess";

export default function About() {
  return (
    <div className="home">
      <Helmet>
        <title>Trippie Air - Delivery Process</title>
        <meta name="description" content="Trippie Air - Delivery Process" />
      </Helmet>
      <div className="container-middle-content">
        <div className="how-to-container">
          <DeliveryProcess />
        </div>
      </div>
    </div>
  );
}
